import { Component, OnInit } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-subscription-dialog',
  templateUrl: './subscription-dialog.component.html',
  styleUrls: ['./subscription-dialog.component.scss']
})
export class SubscriptionDialogComponent implements OnInit {

  constructor(
    public auth: AuthService,
    private analytics: AngularFireAnalytics
  ) { }

  ngOnInit(): void {
  }

  logout() {
    this.auth.logout()
  }

  async pay() {
    await this.analytics.logEvent('checkout')
    window.open("https://swayamapp.com/buy-now", "_blank")
  }

}
